const NO_NAVBAR_ROUTES = ['/user-register', '/user-login'];

export default NO_NAVBAR_ROUTES;
